<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   violation_information: {
    type: Object,
    required: true
   } 
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="row m-3">
        <table class="table table-bordered table-sm table-light m-0">
            <tbody>
                <tr>
                    <th colspan="2" class="text-center">Violation Information</th>
                </tr>
                <tr>
                    <td class="no-wrap">Date</td>
                    <td>{{ props.violation_information.date ? props.violation_information.date : 'n/a' }}</td>
                </tr>
                <tr v-if="props.violation_information.time">
                    <td class="no-wrap">Time</td>
                    <td>{{ props.violation_information.time ? props.violation_information.time : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Location</td>
                    <td>{{ props.violation_information.location ? props.violation_information.camera_id + ' - ' + props.violation_information.location : 'n/a'}}</td>
                </tr>
                 <tr v-if="props.violation_information.lgu">
                    <td class="no-wrap">LGU</td>
                    <td>{{ props.violation_information.lgu ? props.violation_information.lgu : 'n/a'}}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Lane</td>
                    <td>{{ props.violation_information.lane ? props.violation_information.lane : 'n/a'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
